import routes from 'global/Constants/routes';

import { lazy } from 'react';

const DashboardPage = lazy(() => import('../../pages/dashboard/dashboard/DashboardPage'));
// const DashboardPage = lazy(() => import('../../pages/dashboard/dashboard/DashboardPage copy'));
const Setting = lazy(() => import('../../pages/dashboard/setting/Setting'));

export const dashboardRoutes = (hasAccessLevel: (_level: number) => boolean) => [
  {
    path: routes.setting.path,
    component: Setting,
    isPrivate: routes.setting.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.dashboardHome.path,
    component: DashboardPage,
    isPrivate: routes.dashboardHome.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.dashboard.path,
    component: DashboardPage,
    isPrivate: routes.dashboard.isPrivate,
    accessRole: hasAccessLevel(10),
  },
];
